
export const WIDTH_RATIO = 6;
